var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-progress',{staticClass:"bar-progress percent-color",class:_vm.classTime,attrs:{"max":_vm.maxBar}},[_c('b-progress-bar',{attrs:{"value":_vm.proggresBarValue}},[_c('div',{staticClass:"label-progress"},[_c('span',{class:_vm.classTime},[_vm._v(" "+_vm._s(_vm.formatTime)+" ")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }